const btnToggleLeftProd = document.querySelector("#leftArrowProd");
const btnToggleRightProd = document.querySelector("#rightArrowProd");
const itemsProd = document.querySelectorAll(".productImgSlide");
const itemCountStartProd = document.getElementById("sellLengthDivProd");
var itemCountStringProd = itemCountStartProd.innerText;
var thumbItemClicked = 0;
var itemCountProd = parseInt(itemCountStringProd, 10);
console.log(itemCountProd);
var curItemProd = 0;

const hideAllItemsProd = function () {
  [].forEach.call(itemsProd, (el) => {
    el.classList.add("hidden");
  });
};

const updateItemProd = function (itemProdNum) {
  hideAllItemsProd();
  document.getElementById("itemProd-" + itemProdNum).classList.remove("hidden");
  curItemProd = itemProdNum;
  console.log(itemProdNum);
  console.log(curItemProd);
};

const incrementItemProd = function (dir) {
  console.log(curItemProd);
  console.log(dir);
  if (curItemProd + dir > 0 && curItemProd + dir < itemCountProd + 1) {
    updateItemProd(curItemProd + dir);
  }
};

const incrementItemProdThumb = function (dirThumb) {
  console.log(curItemProd);
  console.log(dirThumb);
  updateItemProd(+dirThumb);
};

const prevItemProd = function (e) {
  incrementItemProd(-1);
  console.log(curItemProd);
};

const nextItemProd = function (e) {
  incrementItemProd(+1);
};

const piggyMarket = function (e) {
  var marketAttend = e.currentTarget.getAttribute("data");
  console.log(marketAttend);
  incrementItemProdThumb(+marketAttend);
};
const thumbItems = document
  .querySelectorAll(".productImgSlideThumb")
  .forEach((el) => el.addEventListener("click", piggyMarket));

btnToggleLeftProd.addEventListener("click", prevItemProd);
btnToggleRightProd.addEventListener("click", nextItemProd);

const initProd = function () {
  hideAllItemsProd();
  updateItemProd(1);
};

initProd();
